<template>
    <div class="bg">
        <div class="cont dis-flex3">
            <div class="left_c">
                <p class="hy">Welcome !</p>
                <p class="tit">红名单管理系统</p>
            </div>
            <div class="right_c">
                <p class="tit tits">红名单管理系统</p>
                <input type="text" class="name" placeholder="请输入账户" v-model="name">
                <input type="password" class="pass" placeholder="请输入密码" v-model="pass">
                <p class="dl_btn" @click="dl()">立即登录</p>
            </div>
        </div>
    </div>
    
</template>
<script>
import {signIn} from '@/utils/api'
export default{
    data(){
        return{
            name:'',pass:''
        }
    },
    methods:{
        dl(){
            let param ={
                username:this.name,
                password:this.pass
            }
            signIn(param).then(res=>{
                let userInfo={uid:res.uid,name:res.username}
                localStorage.setItem('userInfo',JSON.stringify(userInfo))
                this.$router.push('/Warehousing').catch(()=>{});
           })
        }
    }
}
</script>
<style scoped>
   .bg{
        width:100%;
        height:100%;
        background:linear-gradient(to right, #01002a,#0056db);
    }
    .dis-flex3{
        display:-webkit-box;
        display:-webkit-flex;
        display:flex;
    }
    .flex_1{
        -webkit-box-flex:1;
        -webkit-flex:1;
        flex:1;
    }
    .cont{
        width:820px;
        height:416px;
        background:#fff;
        border-radius:10px;
        position: fixed;
        top:50%;
        left:50%;
        margin-left:-410px;
        margin-top:-208px;
        box-sizing:border-box;
    }
    .left_c{
        width:460px;
        height:100%;
        color:#fff;
        padding: 157px 0 0 47px;
        background:#101010;
        border-radius:10px 32% 32% 10px;
        box-sizing:border-box;
    }
    .hy{
        font-size:44px;
    }
    .tit{
        font-size:18px;
        line-height:20px;
        margin-top:10px;
    }
    .right_c{
        width:220px;
        height:240px;
        margin:88px auto 0;
    }
    .tits{
        color:#000;
        text-align:center;
        font-weight:bold;
        margin-bottom:37px;
        letter-spacing:1px;
    }
    input{
        width:100%;
        height:40px;
        display:inline-block;
        line-height:40px;
        border-radius:5px;
        font-size:12px;
        text-indent:10px;
        margin-bottom:14px;
        border:1px solid #cccccc;
    }
    .dl_btn{
        width:100%;
        height:38px;
        color:#fff;
        font-size:14px;
        line-height:38px;
        text-align:center;
        background:#000;
        border-radius:5px;
        letter-spacing:2px;
        cursor:pointer;
        margin-top:14px;
    }
</style>



// WEBPACK FOOTER //
// src/components/DengL.vue